@if (formControl()) {
<div class="image form-group">
    <mat-form-field class="form-field">
        <div matPrefix class="image-view">
            <button type="button" mat-mini-fab color="primary"
                [imageHint]="{url: formControl()?.value ?? undefined, valid: formControl()?.valid ?? false}">
                <mat-icon>image_search</mat-icon>
            </button>
        </div>
        <input matInput [readonly]="meta().readonly || readonly()" [placeholder]="meta().name"
            [formControl]="$any(formArray()?.at(arrayIndex() ?? 0) || formControl())">
        @if (formControl()?.value && !meta().readonly && !readonly()) {
        <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        @if (meta().info) {
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('pattern') && !formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is invalid
        </mat-error>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
